module.exports = {"percentiles":"百分位数","byteincomingpercentilesnum":"th 百分位数（传入用量）","traffic":"用量","maximum":"最大值","minimum":"最小值","byteoutgoingpercentilesnum":"th 百分位数（传出用量）","byteincominglinechart":"传入用量趋势","byteoutgoinglinechart":"传出用量趋势","search":"搜寻","exportPdf":"汇出 PDF","moreInfo":"更多信息","ipRange":"IP 地址范围","timeRange":"时间范围"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-CN/netflowAnalyze.json
// module id = Zpnk
// module chunks = 3